"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _internalTypography = require("../../internal/internal-typography");
var _grid = require("../../layouts/grid");
var _stack = require("../../layouts/stack");
var _theme = _interopRequireDefault(require("../checkbox/theme"));
var _constants = require("../../utils/constants");
var _colors = require("../../colors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Radio = function Radio(_ref) {
  var name = _ref.name,
    helperText = _ref.helperText,
    checked = _ref.checked,
    disabled = _ref.disabled,
    label = _ref.label,
    onChange = _ref.onChange,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(StyledLabel, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(_grid.Grid, {
    container: true,
    spacing: 2,
    alignItems: 'baseline'
  }, /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(RadioWrapper, null, /*#__PURE__*/React.createElement(RadioInput, {
    name: name,
    disabled: disabled,
    type: "radio",
    value: value,
    checked: checked,
    onChange: onChange
  }), /*#__PURE__*/React.createElement(VisualRadioButton, null))), /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(_stack.Stack, {
    spacing: 0
  }, label, helperText && /*#__PURE__*/React.createElement(_internalTypography.HelperText, null, helperText)))));
};
var VisualRadioButton = function VisualRadioButton() {
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FilledCircle, null));
};
var FilledCircle = function FilledCircle() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "8",
    height: "8",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4"
  }));
};
var RadioGroup = function RadioGroup(props) {
  var disabled = props.disabled,
    legend = props.legend,
    _onChange = props.onChange,
    options = props.options,
    value = props.value,
    ariaLabel = props.ariaLabel;
  var name = props.name || legend || ariaLabel;
  return /*#__PURE__*/React.createElement(Fieldset, (0, _extends2["default"])({
    "aria-label": ariaLabel
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(_grid.Grid, {
    container: true,
    direction: "column",
    spacing: 2
  }, legend && /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(_internalTypography.Legend, null, legend)), /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(_grid.Grid, {
    direction: "column",
    container: true,
    justifyContent: "flex-start",
    spacing: 1
  }, options.map(function (option) {
    var checked = value === option.value;
    return /*#__PURE__*/React.createElement(_grid.Grid, {
      key: option.value,
      item: true
    }, /*#__PURE__*/React.createElement(Radio, {
      name: name && name.replace(/\s+/g, '-').toLowerCase(),
      helperText: option.helperText,
      disabled: disabled,
      label: option.label,
      value: option.value,
      checked: checked,
      onChange: function onChange(e) {
        return _onChange(option.value, e);
      }
    }));
  })))));
};
RadioGroup.displayName = 'RadioGroup';
RadioGroup.defaultProps = {
  'data-provides': 'radio-group'
};
var Fieldset = _styledComponents["default"].fieldset.withConfig({
  displayName: "radio_group__Fieldset"
})(["border:none;color:", ";font-size:16px;"], _theme["default"]["default"].labelColor);
var StyledLabel = (0, _styledComponents["default"])(_internalTypography.InputOption).withConfig({
  displayName: "radio_group__StyledLabel"
})(["cursor:pointer;", ";"], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && "cursor: not-allowed;\n     color: ".concat(_theme["default"].disabled.labelColor, ";");
});
var RadioInput = _styledComponents["default"].input.withConfig({
  displayName: "radio_group__RadioInput"
})(["margin:0;height:18px;width:18px;"]);
var RadioWrapper = _styledComponents["default"].span.withConfig({
  displayName: "radio_group__RadioWrapper"
})(["input{appearance:none;border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;}input:focus + span::before{content:'';position:absolute;inset:-4px;border:2px solid ", ";border-radius:50%;opacity:1;pointer-events:none;}input:focus + span::after{content:'';position:absolute;inset:-5px;border:1px solid white;border-radius:50%;opacity:1;pointer-events:none;}span{background-color:", ";display:inline-block;position:relative;height:1.125rem;width:1.125rem;margin-top:1px;border:1px solid ", ";border-radius:50%;box-sizing:border-box;top:0.125rem;left:0;svg{fill:", ";opacity:0;position:absolute;top:4px;left:4px;}}input:checked + span > svg{opacity:1;}input:hover + span{border-color:", ";> svg circle{fill:", ";}}input:active + span{border-color:", ";> svg circle{fill:", ";}}input:disabled + span{border-color:", ";box-shadow:none;cursor:not-allowed;> svg circle{fill:", ";}}"], _colors.FOCUS_BORDER_COLOR, _theme["default"].backgroundColor, _theme["default"]["default"].inputColor, _theme["default"]["default"].inputColor, _theme["default"]["default"].hover.inputColor, _theme["default"]["default"].hover.inputColor, _theme["default"]["default"].active.inputColor, _theme["default"]["default"].inputColor, _theme["default"].disabled.inputColor, _theme["default"].disabled.inputColor);
var _default = exports["default"] = RadioGroup;